/** KPI history — daily snapshots from the `kpi_snapshot` table. Lives in the
 *  Admin (dashboard) group alongside dashboard/summary, so it carries the staff
 *  bearer token automatically. The series is written overnight by the
 *  kpi_snapshot_daily task; this read just charts it. */

import { api } from "./client";
import type { KpiHistoryResponse } from "@/types";

/** GET /kpi/history — the daily snapshot series for one KPI (oldest-first).
 *  `from`/`to` are optional inclusive "YYYY-MM-DD" bounds; omit for all history. */
export function getKpiHistory(
  kpiKey: string,
  range: { from?: string; to?: string } = {},
): Promise<KpiHistoryResponse> {
  return api.get<KpiHistoryResponse>("dashboard", "kpi/history", {
    query: { kpi_key: kpiKey, from: range.from, to: range.to },
  });
}
